"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const Insurance = _ref => {
  let {
    title = 'Health Insurance',
    description = 'Health insurances accepted',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    version: "1.1"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("desc", null, description), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.574 9c.4 0 .723.327.723.733v20.533a.728.728 0 0 1-.723.734H3.724A.73.73 0 0 1 3 30.266V9.733C3 9.327 3.324 9 3.723 9h31.85Zm-.724 1.466H4.448v19.067H34.85V10.466Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.543 16.73h9.886c.391 0 .706-.4.706-.891 0-.493-.315-.893-.706-.893h-9.886c-.389 0-.705.4-.705.893 0 .491.316.89.705.89ZM21.543 20.892h9.886c.391 0 .706-.4.706-.891 0-.493-.315-.893-.706-.893h-9.886c-.389 0-.705.4-.705.893 0 .491.316.89.705.89ZM21.543 25.054h9.886c.391 0 .706-.4.706-.891 0-.493-.315-.893-.706-.893h-9.886c-.389 0-.705.4-.705.893 0 .491.316.891.705.891ZM14.806 18.005H17.1c.423 0 .766.34.766.764v3.057a.765.765 0 0 1-.766.765h-2.293v2.294a.764.764 0 0 1-.764.764h-3.057a.765.765 0 0 1-.766-.764V22.59H7.926a.765.765 0 0 1-.764-.765v-3.057c0-.423.343-.764.764-.764h2.293V15.71c0-.422.343-.765.766-.765h3.057c.423 0 .764.343.764.765v2.294Zm1.53 1.528h-2.294a.763.763 0 0 1-.764-.764v-2.294h-1.53v2.294a.764.764 0 0 1-.763.764H8.692v1.529h2.293c.421 0 .764.343.764.764v2.293h1.53v-2.293c0-.421.34-.764.763-.764h2.294v-1.53Z"
  })));
};
var _default = exports.default = (0, _ikon.default)(Insurance);
Insurance.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Insurance",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Health Insurance'",
        "computed": false
      },
      "required": false
    },
    "description": {
      "defaultValue": {
        "value": "'Health insurances accepted'",
        "computed": false
      },
      "required": false
    }
  }
};